<template>
  <div class="fill-height">
    <admin-wrapper :straight-title="computedTitle" :has-buttons="false" :is-fetched="isFetched">
      <template #form>
        <div class="flexContainer">
          <cockpit-link-card :card="card" v-for="(card, index) in cards" :key="index"> </cockpit-link-card>
        </div>
      </template>
    </admin-wrapper>
  </div>
</template>

<script>
import AdminWrapper from '@/components/AdminWrapper';
import { call, get } from 'vuex-pathify';
import CockpitLinkCard from '@/components/CockpitLinkCard';

export default {
  name: 'Cockpit',
  components: { CockpitLinkCard, AdminWrapper },
  data: () => ({
    isFetched: false,
  }),
  computed: {
    statistics: get('statistics/statistics'),
    currentUserName: get('users/currentUser@name'),
    isWaterModuleEnabled: get('admin/additionalModules@WATER_DATA.enabled'),
    isZDMModuleEnabled: get('admin/additionalModules@ZDM_DATA.enabled'),
    isSewerModuleEnabled: get('admin/additionalModules@SEWER_DATA.enabled'),
    isWaterSettingEnabled: get('admin/settingsValues@water_data_module_enabled'),
    isSewerSettingEnabled: get('admin/settingsValues@sewer_data_module_enabled'),
    geoserver: get('admin/geoserver'),
    computedTitle() {
      return this.$i18n.t('admin.cockpit.title', { name: this.currentUserName });
    },
    cards() {
      return [
        {
          icon: 'mdi-layers',
          text: this.$i18n.t('admin.cockpit.core_layers_count', { amount: this.statistics.core_layers_count }),
          action: () => {
            this.$router.push({
              name: 'spatialData',
              params: {
                tab: 1,
              },
            });
          },
          visible: true,
        },
        {
          icon: 'mdi-fire-hydrant',
          text: this.$i18n.t('admin.cockpit.water_layers_count', { amount: this.statistics.water_layers_count }),
          action: () => {
            this.$router.push({
              name: 'WATER',
              params: {
                tab: 1,
              },
            });
          },
          visible: this.isWaterModuleEnabled && this.isWaterSettingEnabled,
        },
        {
          icon: 'mdi-pipe',
          text: this.$i18n.t('admin.cockpit.sewer_layers_count', { amount: this.statistics.sewer_layers_count }),
          action: () => {
            this.$router.push({
              name: 'SEWER',
              params: {
                tab: 1,
              },
            });
          },
          visible: this.isSewerModuleEnabled && this.isSewerSettingEnabled,
        },
        {
          icon: 'mdi-lightbulb',
          text: this.$i18n.t('admin.cockpit.zdm_data_layers_count', { amount: this.statistics.zdm_data_layers_count }),
          action: () => {
            this.$router.push({
              name: 'zdmStreetLights',
              params: {
                tabProp: 1,
              },
            });
          },
          visible: this.isZDMModuleEnabled,
        },
        {
          icon: 'mdi-account-group',
          text: this.$i18n.t('admin.cockpit.users_count', { amount: this.statistics.users_count }),
          action: () => {
            this.$router.push({ name: 'users' });
          },
          visible: true,
        },
        {
          icon: 'mdi-earth',
          text: this.$i18n.t('admin.cockpit.geoserver'),
          buttonTranslationPath: 'button.open',
          action: () => window.open(this.geoserver.url),
          visible: this.geoserver?.available,
        },
      ];
    },
  },
  methods: {
    getStatistics: call('statistics/getStatistics'),
    getGeoserverMetadata: call('admin/getGeoserverMetadata'),
    async onInit() {
      try {
        await Promise.all([this.getGeoserverMetadata(), this.getStatistics()]);
        this.isFetched = true;
      } catch {
        this.isFetched = true;
      }
    },
  },
  created() {
    this.onInit();
  },
};
</script>

<style lang="scss" scoped>
.flexContainer {
  display: flex;
  gap: 1em;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
}
</style>
